import React, { memo } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { styled } from "@mui/system";

const StyledIcon = styled(SvgIcon)({
    width: "18px",
    height: "18px",
    justifySelf: "center",
    alignSelf: "center",
    marginBottom: "-3px",
    marginLeft: "1px",
});

export const ArrowIcon = memo(() => 
    <StyledIcon viewBox="0 0 30 30">
      <path
        d="M24 12l-9-8v6h-15v4h15v6z"
        fill="white"
        fillOpacity="0.87"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </StyledIcon>
  );
